<template>
  <div>
    <b-container fluid class="p-0">
      <main>
        <CommonTitle class="sp-h1-font-size fs-24-bold" :titleProps="'お問い合わせ'"/>
        <b-card class="mt-3 min-vh-75">
            <div class="contact-info-wrap">
              <dl class="contact-info">
                <dt class="contact-info-title">お電話でのご連絡</dt>
                <dd class="contact-info-desc">03-5958-9331</dd>
              </dl>
              <dl class="contact-info">
                <dt class="contact-info-title">お問い合わせフォームからのご連絡</dt>
                <dd class="contact-info-desc"><b-button variant="primary" pill href="/mypage/inquiry/input" class="fs-14-bold" type="submit">お問い合わせはこちら</b-button></dd>
              </dl>
            </div>
            <p class="mb-0">
              営業時間：9:00～21:00 ※夏季・冬季・GW特別期間を除く年中無休。<br>
              お問い合わせ時はお客様ID（TASID）をお伝えください。<br>
              24時間コースをご契約中のお客様は「転送先番号のご案内」に記載されている番号へご連絡をお願いいたします。
            </p>
        </b-card>
      </main>
    </b-container>
  </div>
</template>
<script>

// NOTE: 共通タイトルUI
import CommonTitle from '../../components/common/CommonTitle'

export default {
  components: {
    CommonTitle
  },
  computed: {
    isSpUserAgent () {
      return navigator.userAgent.match(/iPhone|Android.+Mobile/)
    }
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 480px) {
    .sp-h1-font-size {
      font-size: 1.5rem !important;
    }
    .sp-button-size {
      width: 200px !important;
    }
    .sp-button-center {
      text-align: center !important;
    }
}

.contact-info {
  display: flex;
  flex-wrap: wrap;
  align-items: center;;
}

.contact-info-title {
  width: 20rem;
  font-weight: normal;
  font-size: 1.25rem;
}

.contact-info-desc {
  width: calc(100% - 20rem);
  margin-bottom: 0;
  font-size: 1.25rem;
  font-weight: bold;
}

.contact-info-wrap {
  margin-bottom: 24px;
}

@media screen and (max-width: 1023px) {
  .contact-info-title {
    width: 100%;
    margin-bottom: 0.25rem;
  }

  .contact-info-desc {
    width: 100%;
  }
}

.min-vh-75{
  min-height: 75vh;
}
</style>
